import React from "react"

export default function Header() {
    return (
        <header className="header">
            <img 
                src="https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/cb647821-dc91-4178-847f-42c98fbcd407/deogqv8-c614049b-bcf6-440a-9765-9f0b8299e350.png/v1/fill/w_1032,h_774,q_70,strp/troll_face__traced__by_ordinarycarrot16_deogqv8-pre.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9MTQ0MCIsInBhdGgiOiJcL2ZcL2NiNjQ3ODIxLWRjOTEtNDE3OC04NDdmLTQyYzk4ZmJjZDQwN1wvZGVvZ3F2OC1jNjE0MDQ5Yi1iY2Y2LTQ0MGEtOTc2NS05ZjBiODI5OWUzNTAucG5nIiwid2lkdGgiOiI8PTE5MjAifV1dLCJhdWQiOlsidXJuOnNlcnZpY2U6aW1hZ2Uub3BlcmF0aW9ucyJdfQ.G8YL1eS33Wvox03xuh0fU5YEtGPCmF8RRkgLZQlz0N8" 
                className="header--image"
            />
            <h2 className="header--title">Meme Generator</h2>
            <h4 className="header--project">React Course - Project 3</h4>
        </header>
    )
}